import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneySocialTop = defineTemplate({
  mode: 'legacy',
  id: 'social-top',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Top',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/top.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/top.png`,
    hoverVideo: `${BASE}/previews/top.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
